export default (r: any): {}[] => {
	return r.keys().map(r);
};
